"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgShuttle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956 220.5h-43v-15.4c0-83.8-67.9-152-151.2-152H262.2c-83.4 0-151.2 68.2-151.2 152v15.4H54.1C24.3 220.5 0 244.9 0 274.9v139.5c0 30 24.3 54.3 54.1 54.3H111v390.5h55.5v43.3c0 37.7 30.5 68.3 68 68.3h111c37.5 0 68-30.6 68-68.3v-43.3h197v43.3c0 37.7 30.5 68.3 68 68.3h111c37.5 0 68-30.6 68-68.3v-43.3H913l-.2-347.2v-43.3H956c37.5 0 68-30.6 68-68.3V288.8c0-37.6-30.5-68.3-68-68.3zm-10.7 76.2v95h-27.7v-95h27.7zm-114.1-95.2V219H198.7v-17.5c0-42.7 31.3-77.5 69.7-77.5h493.2c38.3 0 69.6 34.8 69.6 77.5zM546.9 492.2V298.7h278.4v193.5H546.9zm284.3 94.2V780H198.7V586.4h632.5zm-632.5-94.2V298.7h278.4v193.5H198.7zm-92.4-195.5v95H78.7v-95h27.6zm186.2 310.6c40.9 0 74 32.5 74 72.5s-33.1 72.5-74 72.5-74-32.5-74-72.5 33.1-72.5 74-72.5zm439 0c40.9 0 74 32.5 74 72.5s-33.1 72.5-74 72.5-74-32.5-74-72.5 33.1-72.5 74-72.5z"
  }));
}

var ForwardRef = React.forwardRef(SvgShuttle);
var _default = ForwardRef;
exports.default = _default;